import { apiClient } from '../../../shared/utils/apiClient';
import type {
  ActivitiesListResponse,
  ActivityItem,
  ListActivitiesParams,
  ReadAllResponse,
  UnreadCountResponse
} from '../types';
import { unwrap } from './unwrap';
import type { UnwrapOptions } from './unwrap';

export const activitiesApi = {
  // Pass { redirectOnUnauthorized: false } from background polling so an
  // expired session stops the poll quietly instead of redirecting.
  async unreadCount(options: UnwrapOptions = {}): Promise<UnreadCountResponse> {
    return unwrap(await apiClient.get<UnreadCountResponse>('/api/v1/activities/unread_count'), options);
  },

  async list({ limit = 20, cursor, group }: ListActivitiesParams = {}): Promise<ActivitiesListResponse> {
    const params = new URLSearchParams();
    params.set('limit', String(limit));
    if (cursor) params.set('cursor', String(cursor));
    if (group) params.set('group', group);
    return unwrap(await apiClient.get<ActivitiesListResponse>(`/api/v1/activities?${params.toString()}`));
  },

  async markRead(id: number): Promise<ActivityItem> {
    return unwrap(await apiClient.post<ActivityItem>(`/api/v1/activities/${id}/read`, {}));
  },

  async markAllRead(): Promise<ReadAllResponse> {
    return unwrap(await apiClient.post<ReadAllResponse>('/api/v1/activities/read_all', {}));
  }
};
